import { apiClient } from './client';

/**
 * Course tariffs (CoursePricing). The backend keeps the course price equal to the cheapest
 * active tariff, and checkout charges the tariff the student picks.
 */

/** Every tariff of a course, inactive ones included (ADMIN / MODERATOR). */
export async function getCourseTariffs(courseId) {
  const { data } = await apiClient.get(`/courses/${courseId}/pricing/manage`);
  return Array.isArray(data) ? data : [];
}

/** @param {{ name: string, price: number, description?: string|null, isActive?: boolean, isDefault?: boolean, orderIndex?: number }} body */
export async function createCourseTariff(courseId, body) {
  const { data } = await apiClient.post(`/courses/${courseId}/pricing`, body);
  return data;
}

export async function updateCourseTariff(courseId, tariffId, body) {
  const { data } = await apiClient.patch(`/courses/${courseId}/pricing/${tariffId}`, body);
  return data;
}

export async function retireCourseTariff(courseId, tariffId) {
  await apiClient.delete(`/courses/${courseId}/pricing/${tariffId}`);
}
